export enum HomepageHeroVariants {
  Centered = 'Centered',
  TwoColumn = 'Two Column',
}
